import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
// import { validateLabelInput } from '../../services/actions/pharmacy/dispense/labelValidateUpdateInputs';
import { updateExpiry, updateProcessingForVials } from '../../services/actions/pharmacy/dispense/updateExpiry';
import { UpdateBlisterDailyPack, UpdateBlisterPack, UpdateDailyMedicationPack, UpdateDailyVailsPack, UpdateMedicationPack } from '../../services/actions/pharmacy/blisters/addBlisterPackData';
import { currentDate } from '../../utils/constants/formInitialStates';

export const editTimeOffRequestStartDatePicker = (startDatePickerRef, setStartDateValue, startDateValue) => {
	let startDatepickerInstance;

	if (startDatePickerRef.current) {
		startDatepickerInstance = flatpickr(startDatePickerRef.current, {
			dateFormat: 'Y-m-d',
			defaultDate: startDateValue,
			onChange: function (selectedDates, dateStr, instance) {
				setStartDateValue(dateStr);
			},
		});
	}

	return startDatepickerInstance;
}

export const editTimeOffRequestEndDatePicker = (endDatePickerRef, setEndDateValue, endDateValue) => {
	let endDatepickerInstance;

	if (endDatePickerRef.current) {
		endDatepickerInstance = flatpickr(endDatePickerRef.current, {
			dateFormat: 'Y-m-d',
			defaultDate: endDateValue,
			onChange: function (selectedDates, dateStr, instance) {
				setEndDateValue(dateStr);
			},
		});
	}
	return endDatepickerInstance;
}

export const timeSheetStartDatePicker = (startDatePickerRef, setStartDateValue, setMessage, startDateValue, setEndDateValue) => {
	let startDatepickerInstance;

	if (startDatePickerRef.current) {
		startDatepickerInstance = flatpickr(startDatePickerRef.current, {
			defaultDate: startDateValue,
			dateFormat: 'Y-m-d',
			onChange: function (selectedDates, dateStr, instance) {
				setStartDateValue(dateStr);
				const endDate = new Date(dateStr);
				endDate.setDate(endDate.getDate() + 7);
				setEndDateValue(endDate.toISOString().split('T')[0]);
				setMessage('')
			},
		});
	}
	return startDatepickerInstance;
}

export const timeSheetEndDatePicker = (endDatePickerRef, setEndDateValue, setMessage, endDateValue) => {
	let endDatepickerInstance;
	if (endDatePickerRef.current) {
		endDatepickerInstance = flatpickr(endDatePickerRef.current, {
			defaultDate: endDateValue,
			dateFormat: 'Y-m-d',
			onChange: function (selectedDates, dateStr, instance) {
				setEndDateValue(dateStr);
				setMessage('');
			},
		});
	}

	return endDatepickerInstance;
};

export function endDateUpdate(delta, endDatePickerRef) {
	if (endDatePickerRef.current && endDatePickerRef.current._flatpickr) {
		const currentDate = endDatePickerRef.current._flatpickr.selectedDates[0];
		if (currentDate) {
			const newDate = new Date(currentDate);
			newDate.setDate(currentDate.getDate() + delta);
			endDatePickerRef.current._flatpickr.setDate(newDate, true);
		}
	}
}

export function startDateUpdate(delta, startDatePickerRef) {
	if (startDatePickerRef.current && startDatePickerRef.current._flatpickr) {
		const currentDate = startDatePickerRef.current._flatpickr.selectedDates[0];
		if (currentDate) {
			const newDate = new Date(currentDate);
			newDate.setDate(currentDate.getDate() + delta);
			startDatePickerRef.current._flatpickr.setDate(newDate, true);
		}
	}
}

export const initialPharmacyTodaysDate = (DateRef,
	setFormData,
	formData,
	type,
	dispatch,
	setShowModal,
	showModal,
	memoID,
	searchParam,
	setShowToast,
	showToast,
	fetchType = '',
	pageNumber,
	filterParam,
	data,
	billedType,
	filterData
) => {

	let todaysDate;

	if (DateRef.current) {
		todaysDate = flatpickr(DateRef.current, {
			dateFormat: 'Y-m-d',
			minDate: 'today',

			onChange: function (selectedDates, dateStr, instance) {

				if (fetchType === 'blister_pack') {
					const requestData = {
						pack_id: memoID,
						'date': dateStr
					}

					dispatch(UpdateBlisterPack('update_blister_pack',
						requestData,
						setShowModal,
						setShowToast,
						pageNumber,
						data))

				} else if (fetchType === 'daily_pack') {

					const requestData = {
						pack_id: memoID,
						'due_date': dateStr
					}

					dispatch(UpdateBlisterDailyPack('update_blister_daily_pack', requestData, setShowModal, setShowToast, pageNumber, 'due_date', filterParam))

				}

				else if (fetchType === 'daily_vials') {
					const requestData = {
						pack_id: memoID,
						'due_date': dateStr
					}
					dispatch(UpdateDailyVailsPack('update_daily_vials_pack',
						requestData,
						setShowModal,
						setShowToast,
						pageNumber,
						'due_date',
						billedType,
						filterParam,
						filterData))
				}

				else if (fetchType === 'daily_medication') {
					const requestData = {
						pack_id: memoID,
						'due_date': dateStr
					}

					dispatch(UpdateDailyMedicationPack('update_daily_medication_pack',
						requestData,
						setShowModal,
						setShowToast,
						pageNumber,
						'due_date',
						filterParam))
				}

				else if (fetchType === 'speciality_medication') {
					const requestData = {
						pack_id: memoID,
						'date': dateStr
					}

					dispatch(UpdateMedicationPack('update_medication_pack', requestData, setShowModal, setShowToast, pageNumber, 'processing_date',filterParam))
				}

				else {

					if (type === 'isvaliddate') {
						setFormData((prevFormData) => ({
							...prevFormData,
							datevalid: dateStr
						}));

						dispatch(updateExpiry('update_reminder', {
							id: memoID,
							next_reminder: dateStr
						}, showToast, setShowToast, searchParam, setShowModal, showModal))

					} else {
						setFormData((prevFormData) => ({
							...prevFormData,
							date: dateStr,
						}));
					}
				}
			},
		});
	}
	return todaysDate;
}

export const initialAddPateintDOBPicker = (dobRef, setPatientFormData, patientFormData) => {
	let startDOBPickerInstance;

	if (dobRef.current) {
		startDOBPickerInstance = flatpickr(dobRef.current, {
			// dateFormat: 'Y-m-d',
			dateFormat: 'Y-m-d',
			altInput: true,
			altFormat: 'M j, Y',
			maxDate: 'today',
			defaultDate: patientFormData.dob,
			onChange: function (selectedDates, dateStr, instance) {
				setPatientFormData((prevPatientFormData) => ({
					...prevPatientFormData,
					dob: dateStr
				}));
			},
		});
	}
	return startDOBPickerInstance;
}

export const initialPharmacyTransferDate = (DateRef, setFormData) => {
	let todaysDate;

	if (DateRef.current) {
		todaysDate = flatpickr(DateRef.current, {
			dateFormat: 'Y-m-d',
			minDate: 'today',
			onChange: function (selectedDates, dateStr, instance) {
				setFormData((prevFormData) => ({
					...prevFormData,
					transferDate: dateStr,
					prescribingDate: dateStr,
				}));
			},
		});
	}
	return todaysDate;
}

export const initialPharmacyPrescribingStartDate = (DateRef, setFormData, formData) => {
	let todaysDate;

	if (DateRef.current) {
		todaysDate = flatpickr(DateRef.current, {
			dateFormat: 'Y-m-d',
			minDate: 'today',
			onChange: function (selectedDates, dateStr, instance) {
				setFormData((prevFormData) => ({
					...prevFormData,
					prescribingStartDate: dateStr,
				}));
			},
		});
	}
	return todaysDate;
}

export const initialPharmacyDatePicker = (DateRef, setFormData, key, type, handleFormDataChange, univalue, minDateOverride) => {
	let todaysDate;

	if (DateRef.current) {

		// const tomorrow = new Date(currentDate);
		// tomorrow.setDate(tomorrow.getDate() + 1);
		// const tomorrowStr = tomorrow.toISOString().split('T')[0];
		// const minDate = minDateOverride || (type === 'removeToday' ? undefined : type === 'flexiDeliveryDate' ? tomorrowStr : 'today');

		const minDate = minDateOverride || (type === 'removeToday' ? undefined : 'today');
		todaysDate = flatpickr(DateRef.current, {
			dateFormat: 'Y-m-d',
			minDate,
			onChange: function (selectedDates, dateStr, instance) {
				setFormData((prevFormData) => ({
					...prevFormData,
					[key]: dateStr
				}));
				if (handleFormDataChange && univalue === 'investigateRx_start_date') {
                     const event = {
                         target: {
                            name: key,
                            value: dateStr
                        }
                    };
                    handleFormDataChange(event);
                }
			},
		});
	}
	return todaysDate;
}

export const initialPharmacyPreviousDatePicker = (DateRef, setFormData, formData, key, minDate = null, maxDate = 'today') => {
	let todaysDate;

	if (DateRef.current) {
		todaysDate = flatpickr(DateRef.current, {
			dateFormat: 'Y-m-d',
			minDate: minDate,
			maxDate: maxDate,
			onChange: function (selectedDates, dateStr, instance) {
				setFormData((prevFormData) => ({
					...prevFormData,
					[key]: dateStr
				}));
			},
		});
	}
	return todaysDate;
}

export const dataRangePicker = (DateRef, setFormData, formData, key) => {
	let todaysDate;
	if (DateRef.current) {
		todaysDate = flatpickr(DateRef.current, {
			dateFormat: 'Y-m-d',
			minDate: key === 'startDate' ? null : 'today',
			onChange: function (selectedDates, dateStr, instance) {
				setFormData((prevFormData) => ({
					...prevFormData,
					[key]: dateStr
				}));
			}
		});
	}

	return todaysDate;
};



export const ArchivedDelveriesDatePicker = (DateRef, setFormData, formData, key, startDate, type = '') => {
	let todaysDate;
	if (DateRef.current) {
		// Only apply 'today' as minDate for start date when type is 'create_task'
		const minDate = key === 'endDate' ? startDate : (type === 'create_task' ? 'today' : null);
		
		todaysDate = flatpickr(DateRef.current, {
			dateFormat: 'Y-m-d',
			minDate: minDate,
			// maxDate: 'today',
			onChange: function (selectedDates, dateStr, instance) {
				setFormData((prevFormData) => ({
					...prevFormData,
					[key]: dateStr
				}));
			}
		});
	}

	return todaysDate;
};

// export const ArchivedDelveriesDatePicker = (DateRef, setFormData, formData, key, startDate) => {
// 	let todaysDate;
// 	if (DateRef.current) {
// 		todaysDate = flatpickr(DateRef.current, {
// 			dateFormat: 'Y-m-d',
// 			minDate: key === 'endDate' && startDate,
// 			maxDate: new Date().fp_incr(4),
// 			onChange: function (selectedDates, dateStr, instance) {
// 				setFormData({
// 					...formData,
// 					[key]: dateStr
// 				});
// 			}
// 		});
// 	}

// 	return todaysDate;
// };

export const initialPharmacyDispenseTodaysDate = (DateRef, setFormData, type = 'default', dispatch, _unused, range = {}) => {
	let todaysDate;

	if (DateRef.current) {
		// Destroy existing instance if it exists
		if (DateRef.current._flatpickr) {
			DateRef.current._flatpickr.destroy();
		}

		const getYesterdayDate = () => {
			const yesterday = new Date(currentDate);
			yesterday.setDate(yesterday.getDate() - 1);
			return yesterday.toISOString().split('T')[0];
		};

		// Set maxDate based on type
		let maxDateValue;
		if (type === 'update_label') {
			maxDateValue = undefined; // No restriction
		} else if (type === 'drug_date') {
			maxDateValue = getYesterdayDate(); // Yesterday (no current/future dates)
		} else {
			maxDateValue = 'today'; // Default behavior - restrict future dates
		}

		const config = {
			dateFormat: 'Y-m-d',
			onChange: function (selectedDates, dateStr, instance) {
				setFormData((prevFormData) => ({
					...prevFormData,
					date: dateStr
				}));
			}
		};

		// Only set maxDate if it's defined
		if (maxDateValue !== undefined) {
			config.maxDate = maxDateValue;
		}

		// An explicit range wins: a caller that knows which days it can answer for (the PharmaNet
		// Elsewhere tab) greys out the rest of the calendar rather than letting an empty day be picked.
		if (range && range.minDate) {
			config.minDate = range.minDate;
		}
		if (range && range.maxDate) {
			config.maxDate = range.maxDate;
		}

		todaysDate = flatpickr(DateRef.current, config);
	}
	return todaysDate;
}


export const initialPharmacBlisterTodaysDate = (DateRef, setDate, initialDate) => {
	let todaysDate;
	if (DateRef.current) {
		todaysDate = flatpickr(DateRef.current, {
			dateFormat: 'Y-m-d',
			// maxDate: 'today',
			defaultDate: initialDate ? initialDate.date : null,
			onChange: function (selectedDates, dateStr, instance) {
				setDate(dateStr);
			},
		});
	}
	return todaysDate;
};



export const initialAddPatientFromDatePicker = (dobRef, setPatientFormData, patientFormData) => {
	let startDOBPickerInstance;

	if (dobRef.current) {
		startDOBPickerInstance = flatpickr(dobRef.current, {
			dateFormat: 'Y-m-d',
			maxDate: 'today',
			defaultDate: patientFormData.fromdate,
			onChange: function (selectedDates, dateStr, instance) {
				alert("dateStr")
				setPatientFormData((prevPatientFormData) => ({
					...prevPatientFormData,
					fromdate: dateStr
				}));
			},
		});
	}
	return startDOBPickerInstance;
}

/**
 * @param {React.RefObject} dobRef
 * @param {Function} setFormData
 * @param {Object} formData
 * @param {Object} [options] - Optional. { displayYmd: true } to show date as Y-m-d in the input (e.g. 2026-01-14) instead of "M j, Y" (e.g. Jan 14, 2026)
 */
export const initalTeamDOBPicker = (dobRef, setFormData, formData, options = {}) => {
	let startDOBPickerInstance;

	if (dobRef.current) {
		const displayYmd = options.displayYmd === true;
		startDOBPickerInstance = flatpickr(dobRef.current, {
			dateFormat: 'Y-m-d',
			altInput: true,
			altFormat: displayYmd ? 'Y-m-d' : 'M j, Y',
			// altFormat: 'M d, Y',
			maxDate: 'today',
			defaultDate: formData?.dob || null,
			onChange: function (selectedDates, dateStr, instance) {
				setFormData((prev) => ({
					...prev,
					dob: dateStr
				}));
			},
		});
	}
	return startDOBPickerInstance;
}

export const initialPharmacyTodaysDateForVials = (DateRef,
	setFormData,
	formData,
	type,
	dispatch,
	setShowModal,
	showModal,
	memoID,
	searchParam,
	setShowToast,
	showToast,
	pageNumber,
	data
) => {

	let todaysDate;
	if (DateRef.current) {
		todaysDate = flatpickr(DateRef.current, {
			dateFormat: 'Y-m-d',
			minDate: 'today',
			onChange: function (selectedDates, dateStr, instance) {
				if (type === 'isvaliddate') {
					// setFormData({
					// 	...formData,
					// 	datevalid: dateStr
					// });
					setFormData((prev) => ({
						...prev,
						datevalid: dateStr
					}));
					dispatch(updateProcessingForVials('update_processing_date', {
						pack_id: memoID,
						date: dateStr
					},
						showToast,
						setShowToast,
						data,
						pageNumber))
				} else {
					// setFormData({
					// 	...formData,
					// 	date: dateStr,
					// });
					setFormData((prev) => ({
						...prev,
						date: dateStr
					}));
				}
			},
		});
	}
	return todaysDate;
}

export const initalVaccineDatePicker = (DateRef, setDate, initialDate) => {
	let todaysDate;
	if (DateRef.current) {
		todaysDate = flatpickr(DateRef.current, {
			dateFormat: "Y-m-d",
			defaultDate: initialDate ? initialDate.date : null,
			onChange: function (selectedDates, dateStr) {
				setDate(dateStr);
			},
		});
	}
	return todaysDate;
};


export const AccountabilityDateRangePicker = (DateRef, setFormData, formData, key, startDate) => {
	let todaysDate;
	if (DateRef.current) {
		// Get yesterday's date
		const getYesterdayDate = () => {
			const yesterday = new Date(currentDate);
			yesterday.setDate(yesterday.getDate() - 1);
			return yesterday.toISOString().split('T')[0];
		};
		todaysDate = flatpickr(DateRef.current, {
			dateFormat: 'Y-m-d',
			maxDate: getYesterdayDate(),
			minDate: key === 'endDate' ? startDate : null,
			onChange: function (selectedDates, dateStr, instance) {
				setFormData((prevFormData) => ({
					...prevFormData,
					[key]: dateStr
				}));
			}
		});
	}

	return todaysDate;
};


export const initialPharmacyPatientDatePicker = (DateRef, onChange) => {
	let todaysDate;

	if (DateRef.current) {
		todaysDate = flatpickr(DateRef.current, {
			dateFormat: 'Y-m-d',
			altInput: false,
			maxDate: currentDate,
			defaultDate: DateRef.current.value,
			onChange: function(selectedDates, dateStr, instance) {
				// Calculate age
				const birthDate = new Date(dateStr);
				const today = new Date(currentDate);
				let age = today.getFullYear() - birthDate.getFullYear();
				const monthDiff = today.getMonth() - birthDate.getMonth();
				
				if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
					age--;
				}
				
				// Call the original onChange with both date and age
				onChange(dateStr, age);
			}
		});
	}
	return todaysDate;
}

export const initialPharmacyDatePickerWithMinDate = (DateRef, setFormData, key, type, minDate) => {
	let todaysDate;

	if (DateRef.current) {
		todaysDate = flatpickr(DateRef.current, {
			dateFormat: 'Y-m-d',
			minDate: type === 'removeToday' ? (minDate || undefined) : 'today',
			onChange: function (selectedDates, dateStr, instance) {
				setFormData((prevFormData) => ({
					...prevFormData,
					[key]: dateStr
				}));
			},
		});
	}
	return todaysDate;
}

// Date picker for Rx Sheet filter - only allows dates up to yesterday (disables today and future dates)
export const initialRxSheetDatePicker = (DateRef, setFormData, formData, key) => {
	let datePickerInstance;

	if (DateRef.current) {
		// Calculate yesterday's date based on currentDate (parse without timezone issues)
		const getYesterdayDate = () => {
			const [year, month, day] = currentDate.split('-').map(Number);
			const yesterday = new Date(year, month - 1, day); // month is 0-indexed
			yesterday.setDate(yesterday.getDate() - 1);
			
			// Format as YYYY-MM-DD
			const newYear = yesterday.getFullYear();
			const newMonth = String(yesterday.getMonth() + 1).padStart(2, '0');
			const newDay = String(yesterday.getDate()).padStart(2, '0');
			return `${newYear}-${newMonth}-${newDay}`;
		};

		const MIN_DATE = '';

		datePickerInstance = flatpickr(DateRef.current, {
			dateFormat: 'Y-m-d',
			minDate: MIN_DATE,          // 🚫 hide all dates before 2026-01-02
            // defaultDate: MIN_DATE,      // ✅ start from 2026-01-02
			maxDate: getYesterdayDate(), // Only allow dates up to yesterday
			defaultDate: getYesterdayDate(), // Default to yesterday
			onChange: function (selectedDates, dateStr, instance) {
				setFormData((prevFormData) => ({
					...prevFormData,
					[key]: dateStr
				}));
			},
		});
	}
	return datePickerInstance;
}
